/**
 * Whether a want-ad row has an associated client, based on the
 * FirstName/LastName the dashboard list query joins in from Clients.
 */
export const hasAssignedClient = (ad) => {
  const firstName = ad?.FirstName || "";
  const lastName = ad?.LastName || "";
  return !!(firstName || lastName);
};

/**
 * Pulls the API's own error message out of an axios error before falling
 * back to axios's generic "Request failed with status code NNN" text.
 */
export const extractApiErrorMessage = (err, fallback) => {
  return err?.response?.data?.message || err?.message || fallback;
};
